import {
  AfterViewInit,
  Component,
  ComponentFactoryResolver,
  Input,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { DynamicComponent } from "@app/data/dashboard/interfaces/dynamic-component.interface";

@Component({
  selector: "my-tab",
  template: `
    <div [hidden]="!active" class="pane">
      <ng-content></ng-content>
      <ng-template #templateHolder></ng-template>
    </div>
  `,
  styles: [
    `
      .pane {
        height: calc(100vh - 113px);
        /*overflow: scroll;*/
      }
    `,
  ],
})
export class MyTabComponent implements AfterViewInit, OnInit {
  @Input() tabId: string;
  @Input() listTabId: string;
  @Input() title: string;
  changeForm: boolean;
  icon: any;
  active = false;
  isCloseable = true;
  childTemplate: DynamicComponent;

  @ViewChild("templateHolder", { read: ViewContainerRef, static: true })
  templateHolder: ViewContainerRef;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {
    if (this.childTemplate) {
      this.renderTemplate();
    }
  }

  ngAfterViewInit() {}

  // bu fonksiyonun saflaştırılması lazim.
  private renderTemplate() {
    const component = this.childTemplate.template;
    const viewContainerRef = this.templateHolder;
    const componentFactory =
      this.componentFactoryResolver.resolveComponentFactory(component);
    const instance = viewContainerRef.createComponent(componentFactory)
      .instance as any;
    instance.entity = this.childTemplate.dataContext;
    instance.templateContext = this.childTemplate.templateContext;
    instance.tabId = this.childTemplate.tabId;
    instance.listTabId = this.childTemplate.listTabId;
    instance.isReadOnly = this.childTemplate.isReadOnly;
    instance.mode = this.childTemplate.mode;
    if (this.childTemplate.moduleType) {
      instance.moduleType = this.childTemplate.moduleType;
    }
  }
}
